import { menuPrincipal } from './../../utils/menus-apice';
import { Component, computed, DestroyRef, EventEmitter, inject, input, Input, OnInit, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ApiS3Service } from 'src/app/services/api-s3.service';
import { MenusService } from 'src/app/services/menus.service';
import { NgClass, NgStyle } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShowIfAuthorizedModule } from 'src/app/directives/show-if-authorized/show-if-authorized.module';
import { provideIcons, NgIcon } from '@ng-icons/core';
import { menuMobileIcons } from './menu-mobile.icon';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-menu-mobile',
    imports: [
        NgClass,
        ShowIfAuthorizedModule,
        NgIcon,
        NgStyle
    ],
    providers: [provideIcons(menuMobileIcons)],
    templateUrl: './menu-mobile.component.html',
    styleUrl: './menu-mobile.component.scss',
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0, height: 0 }),
                animate('120ms ease-in', style({ opacity: 1, height: '*' })),
            ]),
            transition(':leave', [
                animate('120ms ease-out', style({ opacity: 0, height: 0 })),
            ]),
        ])
    ]
})
export class MenuMobileComponent implements OnInit {
    sessao = input<any>();
    @Input() isRoot!: any;

    @Output() logoutEvent = new EventEmitter<void>();
    @Output() rotaLinkEvent = new EventEmitter<{ url: any, index: any }>();

    protected menuData = menuPrincipal;
    protected menuToggle!: boolean;

    protected readonly isFilial = computed(() => {
        const sessao = this.sessao();
        return !!sessao?.idCompanyGroup && !sessao?.companyGroupAdmin;
    });
    protected readonly isMatriz = computed(() => {
        const sessao = this.sessao();
        return !!sessao?.companyGroupAdmin;
    });

    protected router = inject(Router);
    private menusService = inject(MenusService);
    protected apiS3 = inject(ApiS3Service);
    private destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.checkMenuToggle();
    }

    private checkMenuToggle = () => {
        this.menusService.toggle.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe(toggle => {
            this.menuToggle = toggle;

            if (!toggle) {
                this.menuData
                    .filter(i => i.subList?.length)
                    .forEach(i => i.open = false);
            }
        })
    }

    protected abrirPerfil = () => {
        this.router.navigateByUrl('/perfil-usuario');
        this.closeMenuToggle();
    }

    private closeMenuToggle() {
        this.menuToggle = false;
        this.menusService.setToggleMenu(false);
    }

    protected sendLogout = () => {
        this.logoutEvent.emit();
    }

    protected sendRotaLinkMenu = (item: any, index: any) => {
        if (item.subList?.length) {
            const currentState = item.open;

            this.menuData
                .filter(i => i.subList?.length)
                .forEach(i => i.open = false);

            item.open = !currentState;
        }
        else if (item?.url) {
            this.rotaLinkEvent.emit({ url: item.url, index })
            this.closeMenuToggle();
        }
    }
}